<template>
  <v-btn color="primary"
         small
         outline
         :loading="loading"
         @click="deliver"
         v-if="canDeliver">
         {{ $t('deliver') }}
  </v-btn>
</template>

<script>
export default {
  name: 'ShipmentDeliverBtnComp',

  props: {
    shipment: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      loading: false
    }
  },

  components: {
  },

  computed: {
    canDeliver () {
      if (!this.$auth.isDev()) { return false }

      return this.shipment.step === 'confirmed' &&
        this.shipment.status === 'success'
    }
  },

  methods: {
    async deliver () {
      if (!this.canDeliver) { return }

      try {
        this.loading = false
        await this.shipment.deliver()
      } catch (err) {
        this.loading = true
      }
      this.$emit('fetch')
    }
  },

  watch: {
  },

  async mounted () {
  }
}
</script>
